import { useIntl } from 'react-intl'
import type { FieldsConfiguration } from 'msp-components'

const getPackstationAddressFields = (): FieldsConfiguration => {
  const { formatMessage } = useIntl()

  return {
    salutation: {
      id: 'salutation',
      type: 'radio',
      name: 'salutation',
      placeholder: '',
      label: formatMessage({
        defaultMessage: 'Salutation',
        id: 'use_address_fields.label.salutation'
      }),
      options: [
        {
          id: 'mr',
          value: 'MR',
          label: formatMessage({
            defaultMessage: 'Mr',
            id: 'msp.label.salutation.mr'
          }),
          extraClassName: 'mr-2'
        },
        {
          id: 'mrs',
          value: 'MRS',
          label: formatMessage({
            defaultMessage: 'Mrs',
            id: 'msp.label.salutation.mrs'
          }),
          extraClassName: 'ml-6 mr-2'
        }
      ],
      isDeselectable: true
    },
    firstName: {
      id: 'firstName',
      type: 'text',
      name: 'firstName',
      placeholder: '',
      label: formatMessage({
        defaultMessage: 'First name',
        id: 'msp.address_form.label.first_name'
      }),
      autoComplete: 'given-name',
      rules: {
        required: formatMessage({
          defaultMessage: 'Please enter your first name.',
          id: 'msp.address_form.error.required_first_name'
        })
      }
    },
    lastName: {
      id: 'lastName',
      type: 'text',
      name: 'lastName',
      placeholder: '',
      label: formatMessage({
        defaultMessage: 'Last name',
        id: 'msp.address_form.label.last_name'
      }),
      autoComplete: 'family-name',
      rules: {
        required: formatMessage({
          defaultMessage: 'Please enter your last name.',
          id: 'msp.address_form.error.required_last_name'
        })
      }
    },
    countryCode: {
      id: 'countryCode',
      name: 'countryCode',
      label: formatMessage({
        defaultMessage: 'Country',
        id: 'msp.address_form.label.country'
      }),
      type: 'select',
      defaultValue: 'DE',
      autoComplete: 'country',
      options: [
        { id: 'AT', value: 'Austria' },
        { id: 'DE', value: 'Germany' }
      ],
      rules: {
        required: formatMessage({
          defaultMessage: 'Please select your country.',
          id: 'msp.address_form.error.please_select_your_country'
        })
      }
    },
    address1: {
      id: 'address1',
      name: 'address1',
      label: formatMessage({
        defaultMessage: 'Packstation',
        id: 'msp.address_form.label.packstation_address'
      }),
      defaultValue: '',
      type: 'text',
      autoComplete: 'street-address',
      rules: {
        required: formatMessage({
          defaultMessage: 'Please select a packstation.',
          id: 'msp.address_form.error.please_select_packstation'
        })
      }
    },
    address2: {
      id: 'address2',
      name: 'address2',
      label: formatMessage({
        defaultMessage: 'DHL Post Number (optional)',
        id: 'msp.address_form.label.dhl_post_number'
      }),
      defaultValue: '',
      type: 'text',
      rules: {
        required: false,
        pattern: {
          value: new RegExp('^\\d{6,10}$'),
          message: formatMessage({
            defaultMessage: 'Please enter a valid DHL Post Number.',
            id: 'msp.address_form.error.invalid_dhl_post_number'
          })
        }
      }
    },
    city: {
      id: 'city',
      name: 'city',
      label: formatMessage({
        defaultMessage: 'City',
        id: 'msp.address_form.label.city'
      }),
      defaultValue: '',
      type: 'text',
      autoComplete: 'address-level2',
      rules: {
        required: formatMessage({
          defaultMessage: 'Please enter your city.',
          id: 'msp.address_form.error.please_select_your_city'
        })
      }
    },
    postalCode: {
      id: 'postalCode',
      name: 'postalCode',
      label: formatMessage({
        defaultMessage: 'Postal Code',
        id: 'msp.address_form.label.postal_code'
      }),
      defaultValue: '',
      type: 'text',
      autoComplete: 'postal-code',
      rules: {
        required: formatMessage({
          defaultMessage: 'Please enter your postal code.',
          id: 'msp.address_form.error.please_enter_your_postal'
        })
      }
    }
  }
}

export default getPackstationAddressFields
